import FeedbackModal from './container';

export default FeedbackModal;



// WEBPACK FOOTER //
// ./src/components/FeedbackModal/index.js